<template>
    <div>
        <div class="level">
            <div class="level-item has-text-centered">
                <div>
                    <figure class="image">
                        <img :src="localImage" class="lb-project-background" />
                    </figure>
                    <div v-if="canEdit" id="button-container">
                        <div class="field is-grouped">
                            <div class="file control">
                                <label v-if="!uploading">
                                    <input
                                        class="file-input"
                                        type="file"
                                        accept="image/*"
                                        multiple="false"
                                        @input="handleImage"
                                    />
                                    <span class="file-cta">
                                        <span
                                            v-t="
                                                'projectConfiguration.select_image'
                                            "
                                            class="file-label"
                                        />
                                    </span>
                                </label>
                                <a v-else class="button is-loading" />
                            </div>

                            <p v-if="localImage" class="control">
                                <a
                                    v-t="'projectConfiguration.delete_image'"
                                    class="button is-danger"
                                    @click="deleteImage"
                                />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { upload } from '@/services/API';
export default {
    props: {
        image: {
            type: Object,
            default: () => {
                return {};
            },
        },
        canEdit: { type: Boolean, default: false },
    },
    data() {
        return {
            localImage: this.image ? this.image.url : null,
            uploading: false,
        };
    },
    methods: {
        async handleImage(ev) {
            if (!ev.target.files) {
                console.log('no files!');
                return;
            }
            var fr = new FileReader();
            fr.onload = () => {
                this.localImage = fr.result;
            };
            fr.readAsDataURL(ev.target.files[0]);
            this.uploading = true;
            let response = await upload(`image`, ev.target.files).catch(
                (err) => {
                    alert(this.$t(`Error.${err}`));
                    this.deleteImage();
                    return this.$emit('error');
                }
            );
            this.uploading = false;
            if (response.data) {
                this.localImage = response.data.image[0].url;
                this.$emit('update:image', response.data.image[0]);
            }
        },
        deleteImage() {
            this.localImage = null;
            this.$emit('update:image', undefined);
        },
    },
};
</script>

<style scoped>
.lb-project-background {
    height: 155px;
    width: 338px;
    border-radius: 4px;
}
img {
    object-fit: cover;
}
.delete {
    margin-bottom: 5px !important;
}
#button-container {
    padding: 5px;
    width: 255px;
}
.file-label {
    line-height: 1.9rem;
}
</style>
